import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface ILocation {
  id: number;
  name: string;
  fullName?: string;
  regionName?: string;
  nameLocative?: string;
  nameGenitive?: string;
  route: string;
  alias: string;
  localityType: string;
  shortLocationType: string;
  latitude: number;
  longitude: number;
}

export interface IState {
  centers: ILocation[];
  currentLocation: ILocation;
}

const initialState: IState = {
  centers: [],
  currentLocation: {
    id: 83,
    name: 'Москва',
    fullName: 'г Москва',
    nameLocative: 'в Москве',
    nameGenitive: 'Москвы',
    route: '6.83.',
    alias: 'moskva',
    localityType: 'город',
    shortLocationType: 'г.',
    latitude: 55.753676,
    longitude: 37.619899,
  },
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setCurrentLocation: (state, { payload }: PayloadAction<ILocation>) => {
      state.currentLocation = payload;
    },
    setLocations: (state, { payload }: PayloadAction<ILocation[]>) => {
      state.centers = payload;
    },
  },
});

const { actions, reducer } = locationSlice;

export const { setCurrentLocation, setLocations } = actions;

export default reducer;
